import { createFileRoute, redirect } from '@tanstack/react-router';

import { useAuth } from '@/store/auth.ts';
import { HomeView } from '@/views/home/home-view.tsx';

// `/` is the public landing (hero + inline sign-in), ported from the original Next
// home page. Already-authenticated users skip it: ADMIN → /admin, everyone else →
// /courses (the learner home). Anonymous visitors see the landing + sign-in form.
export const Route = createFileRoute('/')({
  beforeLoad: () => {
    const { user } = useAuth.getState();
    if (user) {
      throw redirect({ to: user.role === 'ADMIN' ? '/admin' : '/courses' });
    }
  },
  component: HomeView,
});
